/** How many m² are in km². It's 1000 * 1000. */
export const M_SQUARED_TO_KM_SQUARED = 1000000;

/** Maximum area an LSS' polygons can have - 1km² */
export const maxLssPolygonArea = 1 * M_SQUARED_TO_KM_SQUARED;

/** Maximum number of points an LSS can have. */
export const maxLssPoints = 2500;

/** How many metres apart each generated LSS point should be. */
export const lssPointsDensity = 20;
